// Generated by Melange

import * as Caml_format from "melange.js/caml_format.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib from "melange/stdlib.js";

function set(setFn, value) {
  return Curry._1(setFn, (function (param) {
    let tmp;
    if (value === "") {
      tmp = undefined;
    } else {
      try {
        tmp = Caml_format.caml_float_of_string(value);
      }
      catch (exn){
        tmp = undefined;
      }
    }
    return {
      value: tmp,
      text: value
    };
  }));
}

function floatToStr(value) {
  const str = Stdlib.string_of_float(value);
  if (str.endsWith(".", undefined)) {
    return str.substring(0, str.length - 1 | 0);
  } else {
    return str;
  }
}

function init(value) {
  return {
    value: value,
    text: floatToStr(value)
  };
}

const empty = {
  value: undefined,
  text: ""
};

export {
  set,
  empty,
  floatToStr,
  init,
}
/* No side effect */
